import React from "react";
import { motion } from "framer-motion";


const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
        opacity: 1,
        y: 0,
        transition: { delay: i * 0.2, duration: 0.7, ease: "easeOut" }
    })
};

const Home = ({ handleNavClick }) => (
    <section id="home" className="min-h-screen flex items-center bg-gray-900">
        <div className="container mx-auto px-6 text-center">
            <div className="max-w-4xl mx-auto">
                <motion.h1
                    className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-4"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={1}
                >
                    Hi, I'm <span className="text-cyan-400">Rajan Bhalodiya</span>
                </motion.h1>
                <motion.p
                    className="text-xl md:text-2xl text-gray-300 mb-8"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={2}
                >
                    A Passionate Junior Software Developer
                </motion.p>
                <motion.p
                    className="text-lg text-gray-400 max-w-2xl mx-auto mb-10"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={3}
                >
                    I build engaging and user-friendly web experiences with a focus on clean code and modern design.
                </motion.p>
                <motion.div
                    className="flex justify-center space-x-4"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={4}
                >
                    <button
                        onClick={() => handleNavClick('projects')}
                        className="bg-cyan-500 text-white font-bold py-3 px-8 rounded-full hover:bg-cyan-600 transition-transform transform hover:scale-105 shadow-lg"
                    >
                        View My Work
                    </button>
                    <button
                        onClick={() => handleNavClick('contact')}
                        className="bg-gray-700 text-white font-bold py-3 px-8 rounded-full hover:bg-gray-600 transition-transform transform hover:scale-105 shadow-lg"
                    >
                        Get In Touch
                    </button>
                </motion.div>
            </div>
        </div>
    </section>
);

export default Home;
